import { fetchReducerGenerator } from 'redpoints-front-common/reducers';

import {
  INCIDENT_DETAILS_CLEAR,
  INCIDENT_DETAILS_FETCH_DETECTION_LINK_METADATA,
} from '../../../../actions/actionTypes';
import { getMetadataAsMap } from '../../../../helpers/dataHelper';

const detectionLinkMetaData = fetchReducerGenerator(
  INCIDENT_DETAILS_CLEAR,
  INCIDENT_DETAILS_FETCH_DETECTION_LINK_METADATA
);

export default detectionLinkMetaData;

export const getIncidentDetailsDetectionLinkMetaData = state =>
  getMetadataAsMap(state.response.data ?? [], 'modelName');
